/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-09-02 14:58:55
 **/

const Keys = {
	TAB: 9,
	ENTER: "Enter",
	ESCAPE: 27,
	UP: "ArrowUp",
	DOWN: "ArrowDown",
	BACKSPACE: "Backspace",
	SINGLEQUOTE: 192
};

export default Keys;
